import {
  useZoomAccountUsageQuery,
  ZoomAccountUsageFieldsFragment,
} from 'core/graphql';

interface IZoomAccountUsageHook {
  usage?: ZoomAccountUsageFieldsFragment;
  loading: boolean;
  error?: string;
  refetch: () => void;
}

/** Zoom storage/usage summary — backs the dashboard storage widget. */
export const useZoomAccountUsage = (): IZoomAccountUsageHook => {
  const { data, loading, error, refetch } = useZoomAccountUsageQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    usage: data?.zoomAccountUsage ?? undefined,
    loading,
    error: error?.message,
    refetch: () => {
      refetch();
    },
  };
};
